package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Equatorial Guinea Flag (20x15dp)
 *
 * - ISO Alpha-2: GQ
 * - ISO Alpha-3: GNQ
 * - ISO Numeric: 226
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.EquatorialGuinea: ImageVector by lazy {
    ImageVector.Builder(
        name = "Equatorial Guinea:GQ:GNQ:226:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15.36f)
                horizontalLineTo(20.48f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15.36f)
                horizontalLineTo(20.48f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF009D00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(5.12f)
                horizontalLineTo(20.48f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 5.12f)
                verticalLineTo(10.24f)
                horizontalLineTo(20.48f)
                verticalLineTo(5.12f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF80000)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 10.24f)
                verticalLineTo(15.36f)
                horizontalLineTo(20.48f)
                verticalLineTo(10.24f)
                horizontalLineTo(0f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF0075D5)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(0f, 0f)
            verticalLineTo(15.36f)
            lineTo(5.12f, 7.777f)
            lineTo(0f, 0f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15.36f)
                lineTo(5.12f, 7.777f)
                lineTo(0f, 0f)
                close()
            }
        ) {
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.04f
        ) {
            moveTo(9.326f, 5.689f)
            lineTo(9.316f, 5.691f)
            lineTo(9.308f, 5.684f)
            lineTo(9.182f, 5.567f)
            lineTo(9.166f, 5.739f)
            lineTo(9.165f, 5.749f)
            lineTo(9.156f, 5.754f)
            lineTo(9.006f, 5.838f)
            lineTo(9.164f, 5.906f)
            lineTo(9.173f, 5.91f)
            lineTo(9.175f, 5.921f)
            lineTo(9.209f, 6.089f)
            lineTo(9.322f, 5.96f)
            lineTo(9.329f, 5.952f)
            lineTo(9.34f, 5.954f)
            lineTo(9.51f, 5.974f)
            lineTo(9.423f, 5.826f)
            lineTo(9.417f, 5.817f)
            lineTo(9.422f, 5.807f)
            lineTo(9.494f, 5.651f)
            lineTo(9.326f, 5.689f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.04f
        ) {
            moveTo(9.966f, 5.689f)
            lineTo(9.956f, 5.691f)
            lineTo(9.948f, 5.684f)
            lineTo(9.822f, 5.567f)
            lineTo(9.806f, 5.739f)
            lineTo(9.805f, 5.749f)
            lineTo(9.796f, 5.754f)
            lineTo(9.646f, 5.838f)
            lineTo(9.804f, 5.906f)
            lineTo(9.813f, 5.91f)
            lineTo(9.815f, 5.921f)
            lineTo(9.849f, 6.089f)
            lineTo(9.962f, 5.96f)
            lineTo(9.969f, 5.952f)
            lineTo(9.98f, 5.954f)
            lineTo(10.151f, 5.974f)
            lineTo(10.063f, 5.826f)
            lineTo(10.057f, 5.817f)
            lineTo(10.062f, 5.807f)
            lineTo(10.134f, 5.651f)
            lineTo(9.966f, 5.689f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.04f
        ) {
            moveTo(10.606f, 5.689f)
            lineTo(10.596f, 5.691f)
            lineTo(10.588f, 5.684f)
            lineTo(10.462f, 5.567f)
            lineTo(10.446f, 5.739f)
            lineTo(10.445f, 5.749f)
            lineTo(10.436f, 5.754f)
            lineTo(10.286f, 5.838f)
            lineTo(10.444f, 5.906f)
            lineTo(10.453f, 5.91f)
            lineTo(10.455f, 5.921f)
            lineTo(10.489f, 6.089f)
            lineTo(10.602f, 5.96f)
            lineTo(10.609f, 5.952f)
            lineTo(10.62f, 5.954f)
            lineTo(10.79f, 5.974f)
            lineTo(10.703f, 5.826f)
            lineTo(10.697f, 5.817f)
            lineTo(10.702f, 5.807f)
            lineTo(10.774f, 5.651f)
            lineTo(10.606f, 5.689f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.04f
        ) {
            moveTo(11.246f, 5.689f)
            lineTo(11.236f, 5.691f)
            lineTo(11.228f, 5.684f)
            lineTo(11.101f, 5.567f)
            lineTo(11.086f, 5.739f)
            lineTo(11.085f, 5.749f)
            lineTo(11.076f, 5.754f)
            lineTo(10.926f, 5.838f)
            lineTo(11.084f, 5.906f)
            lineTo(11.093f, 5.91f)
            lineTo(11.095f, 5.921f)
            lineTo(11.129f, 6.089f)
            lineTo(11.242f, 5.96f)
            lineTo(11.249f, 5.952f)
            lineTo(11.26f, 5.954f)
            lineTo(11.431f, 5.974f)
            lineTo(11.343f, 5.826f)
            lineTo(11.337f, 5.817f)
            lineTo(11.342f, 5.807f)
            lineTo(11.414f, 5.651f)
            lineTo(11.246f, 5.689f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.04f
        ) {
            moveTo(11.886f, 5.689f)
            lineTo(11.876f, 5.691f)
            lineTo(11.868f, 5.684f)
            lineTo(11.741f, 5.567f)
            lineTo(11.726f, 5.739f)
            lineTo(11.725f, 5.749f)
            lineTo(11.716f, 5.754f)
            lineTo(11.566f, 5.838f)
            lineTo(11.724f, 5.906f)
            lineTo(11.733f, 5.91f)
            lineTo(11.735f, 5.921f)
            lineTo(11.769f, 6.089f)
            lineTo(11.882f, 5.96f)
            lineTo(11.889f, 5.952f)
            lineTo(11.9f, 5.954f)
            lineTo(12.071f, 5.974f)
            lineTo(11.983f, 5.826f)
            lineTo(11.977f, 5.817f)
            lineTo(11.982f, 5.807f)
            lineTo(12.054f, 5.651f)
            lineTo(11.886f, 5.689f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.04f
        ) {
            moveTo(12.526f, 5.689f)
            lineTo(12.516f, 5.691f)
            lineTo(12.508f, 5.684f)
            lineTo(12.382f, 5.567f)
            lineTo(12.366f, 5.739f)
            lineTo(12.365f, 5.749f)
            lineTo(12.356f, 5.754f)
            lineTo(12.206f, 5.838f)
            lineTo(12.364f, 5.906f)
            lineTo(12.373f, 5.91f)
            lineTo(12.375f, 5.921f)
            lineTo(12.409f, 6.089f)
            lineTo(12.522f, 5.96f)
            lineTo(12.529f, 5.952f)
            lineTo(12.54f, 5.954f)
            lineTo(12.71f, 5.974f)
            lineTo(12.623f, 5.826f)
            lineTo(12.617f, 5.817f)
            lineTo(12.622f, 5.807f)
            lineTo(12.694f, 5.651f)
            lineTo(12.526f, 5.689f)
            close()
        }
        path(
            stroke = SolidColor(Color(0xFF373737)),
            strokeLineWidth = 0.08f
        ) {
            moveTo(9.64f, 6.44f)
            horizontalLineTo(12.12f)
            verticalLineTo(8.32f)
            curveTo(12.12f, 9.005f, 11.565f, 9.56f, 10.88f, 9.56f)
            curveTo(10.195f, 9.56f, 9.64f, 9.005f, 9.64f, 8.32f)
            verticalLineTo(6.44f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF6F3E1D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(10.705f, 7.654f)
            curveTo(10.705f, 7.654f, 10.576f, 9.168f, 10.447f, 9.26f)
            curveTo(10.318f, 9.352f, 11.064f, 9.397f, 11.136f, 9.329f)
            curveTo(11.207f, 9.26f, 10.81f, 8.026f, 10.947f, 7.654f)
            curveTo(11.083f, 7.282f, 11.303f, 7.252f, 11.303f, 7.252f)
            curveTo(11.303f, 7.252f, 11.026f, 7.194f, 10.947f, 7.305f)
            curveTo(10.868f, 7.417f, 10.631f, 7.252f, 10.631f, 7.252f)
            lineTo(10.705f, 7.654f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF009D29)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(10.677f, 7.569f)
            horizontalLineTo(10.577f)
            curveTo(10.577f, 7.569f, 10.51f, 7.832f, 10.356f, 7.7f)
            curveTo(10.202f, 7.569f, 9.984f, 7.615f, 9.984f, 7.615f)
            curveTo(9.984f, 7.615f, 10.003f, 7.458f, 10.24f, 7.395f)
            curveTo(10.477f, 7.333f, 10.577f, 6.825f, 10.577f, 6.825f)
            curveTo(10.577f, 6.825f, 10.913f, 6.7f, 11.116f, 6.956f)
            curveTo(11.32f, 7.211f, 11.607f, 7.102f, 11.607f, 7.102f)
            curveTo(11.607f, 7.102f, 11.817f, 7.222f, 11.712f, 7.395f)
            curveTo(11.607f, 7.569f, 11.428f, 7.696f, 11.272f, 7.569f)
            curveTo(11.116f, 7.442f, 10.677f, 7.569f, 10.677f, 7.569f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun EquatorialGuineaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.EquatorialGuinea,
            contentDescription = "Equatorial Guinea Flag"
        )
    }
}
